import { useAuthStore } from '../../stores/authStore';

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const LogoutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 3L10 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M15 8L10 3L5 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const Header = ({ onMenuClick }) => {
  const { admin, logout } = useAuthStore();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <header className="h-16 bg-bg-secondary border-b border-border-color flex items-center justify-between px-4 lg:px-6">
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 text-text-secondary hover:text-text-primary"
          aria-label="Меню"
        >
          <MenuIcon />
        </button>

        <h2 className="text-lg font-semibold text-text-primary hidden sm:block">
          Панель администратора
        </h2>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-accent-primary flex items-center justify-center text-white font-semibold text-sm">
            {admin?.username?.charAt(0).toUpperCase() || 'A'}
          </div>
          <span className="text-sm text-text-secondary hidden sm:block">
            {admin?.username || 'Admin'}
          </span>
        </div>

        <button
          onClick={handleLogout}
          className="p-2 text-text-secondary hover:text-error transition-colors"
          title="Выйти"
        >
          <LogoutIcon />
        </button>
      </div>
    </header>
  );
};
